import _ from 'lodash';
import { Frame } from "scenejs";

const { getWidgetBoundingRectForBreakpoint } = require("./layoutManager");

export const calculateRequestForBreakpoint = (editorSession, widgets, breakpoint) => {
  var left = Number.MAX_SAFE_INTEGER;
  var top = Number.MAX_SAFE_INTEGER;
  var bottom = 0;
  var right = 0;

  if(_.size(widgets) === 0){
    return {
      x: 0,
      y: 0,
      width: 50,
      height: 50,
      widgets: widgets
    }
  }

  widgets.forEach(widget => {
    const wRect = getWidgetBoundingRectForBreakpoint(editorSession, widget, breakpoint);
    if (wRect) {
      left = Math.min(wRect.x, left);
      top = Math.min(wRect.y, top);

      right = Math.max(right, wRect.x + wRect.width);
      bottom = Math.max(bottom, wRect.y + wRect.height);
    }
  });

  const width = Math.ceil(right - left);
  const height = Math.ceil(bottom - top);

  const updatedWidgets = widgets.map(item => {
    const layout = _.get(item, `properties.${breakpoint}.layout`);
    const frame = new Frame(layout);

    if (!layout.width) {
      frame.set('width', 'auto')
    }

    if (!layout.height) {
      frame.set('height', 'auto');
    }

    const rect = getWidgetBoundingRectForBreakpoint(editorSession, item, breakpoint);
    if (rect) {
      const newX = rect.x - left;
      const newY = rect.y - top;

      frame.set('transform', 'translate', `${newX}px, ${newY}px`);
    }

    return {
      ...item,
      properties: {
        ...item.properties,
        [breakpoint]: {
          ...item.properties[breakpoint],
          layout: frame.get()
        }
      }
    }
  });

  return {
    x: left,
    y: top,
    width: width,
    height: height,
    widgets: updatedWidgets
  };
}
